import { prisma, type Prisma, ImportableType } from "client";

export const createImport = async (
  data: Prisma.ImportCreateInput,
  importableId?: string
) => {
  try {
    let connectItems = {};
    if (data.importableType == ImportableType.CONTACT_BOOK_GROUP) {
      connectItems = {
        contactBookGroup: {
          connect: { id: importableId },
        },
      };
    } else if (data.importableType == ImportableType.ORDER && importableId) {
      connectItems = {
        order: {
          connect: { id: importableId },
        },
      };
    }
    const importRecord = await prisma.import.create({
      data: {
        ...data,
        ...connectItems,
      },
    });
    return importRecord;
  } catch (e: any) {
    console.error(e);
    throw new Error(e?.message);
  }
};

export const getImport = async (id: string, type?: ImportableType) => {
  try {
    const importRecord = await prisma.import.findFirst({
      where: {
        id,
        ...(type && { importableType: type }),
      },
      include: {
        failureReasons: true,
        orders: true,
      },
    });
    return importRecord;
  } catch (e: any) {
    console.error(e);
    throw new Error(e?.message ?? "Error getting import record");
  }
};
